import React from "react" ;
import PostsAppBodyHeader from "./PostsAppBodyHeader";
import {Route, Switch} from "react-router-dom";
import {PATH_POSTS_ROOT, PATH_POSTS_DASHBOARD} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import DashboardPanelUserPosts from "root/dashboard/DashboardPanelUserPosts";
import PostsTab from "root/Wieldy/ApplicationModules/Posts/Body/PostsTab";

const PostsAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <PostsAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_POSTS_DASHBOARD} render={(thisprops) => <DashboardPanelUserPosts title='Posts To Approve' {...thisprops}/>}/>
                        <Route path={PATH_POSTS_ROOT}render={(thisprops) => <PostsTab child_uid='all' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default PostsAppBody;
